import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

const Page404 = resolve => require(['./pages/errors/Page404'], resolve)
const PageHome = resolve => require(['./pages/PageHome'], resolve)
const PageCompanyDetails = resolve => require(['./pages/PageCompanyDetails'], resolve)

const PageLogin = resolve => require(['./pages/auth/PageLogin'], resolve)
const PageUserRegistration = resolve => require(['./pages/auth/PageUserRegistration'], resolve)
const PagePasswordReset = resolve => require(['./pages/auth/PagePasswordReset'], resolve)

const PageTransports = resolve => require(['./pages/PageTransports'], resolve)
const PageEmployees = resolve => require(['./pages/PageEmployees'], resolve)
const PageHelp = resolve => require(['./pages/PageHelp'], resolve)
const PageMailing = resolve => require(['./pages/PageMailing'], resolve)

const PagePlans = resolve => require(['./pages/PagePlans'], resolve)

const PageFinancesInvoices = resolve => require(['./pages/PageFinancesInvoices'], resolve)
const PageFinancesDashboard = resolve => require(['./pages/PageFinancesDashboard'], resolve)
const PageFinancesAccounts = resolve => require(['./pages/PageFinancesAccounts'], resolve)

const PageMktp = resolve => require(['./pages/PageMktp'], resolve)

const PageRentsDashboard = resolve => require(['./pages/PageRentsDashboard'], resolve)
const PageRentsAdd = resolve => require(['./pages/PageRentsAdd'], resolve)
const PageRents = resolve => require(['./pages/PageRents'], resolve)
const PageRentsDetails = resolve => require(['./pages/PageRentsDetails'], resolve)

const PageClients = resolve => require(['./pages/PageClients'], resolve)
const PageClientsAddOld = resolve => require(['./pages/PageClientsAddOld'], resolve)
const PageClientsAdd = resolve => require(['./pages/PageClientsAdd'], resolve)
const PageClientsDetails = resolve => require(['./pages/PageClientsDetails'], resolve)
const PageClientResume = resolve => require(['./pages/PageClientResume'], resolve)

const PageShoppingManagement = resolve => require(['./pages/PageShoppingManagement'], resolve)
const PageShoppingCatalog = resolve => require(['./pages/PageShoppingCatalog'], resolve)
const PageShoppingAnnouncement = resolve => require(['./pages/PageShoppingAnnouncement'], resolve)

const PageProducts = resolve => require(['./pages/PageProducts'], resolve)
const PageProductsDetails = resolve => require(['./pages/PageProductsDetails'], resolve)
const PageProductsSkuDetails = resolve => require(['./pages/PageProductsSkuDetails'], resolve)

const PageOrders = resolve => require(['./pages/PageOrders'], resolve)
const PageDatavalidImageExample = resolve => require(['./pages/PageDatavalidImageExample'], resolve)

const PartialHeader = resolve => require(['./pages/partials/PartialHeader'], resolve)

const routes = [
  {path: '/', components: {default: PageHome, menu: PartialHeader}, name: 'home'},
  {path: '/login', components: {default: PageLogin, menu: PartialHeader}, name: 'login'},
  {path: '/password-reset', components: {default: PagePasswordReset, menu: PartialHeader}, name: 'password_reset'},
  {path: '/user-registration', components: {default: PageUserRegistration, menu: PartialHeader}, name: 'user_registration'},

  {path: '/company', components: {default: PageCompanyDetails, menu: PartialHeader}, name: 'company_details'},

  {path: '/transports', components: {default: PageTransports, menu: PartialHeader}, name: 'shipping'},
  {path: '/employees', components: {default: PageEmployees, menu: PartialHeader}, name: 'employees'},
  {path: '/help', components: {default: PageHelp, menu: PartialHeader}, name: 'help'},
  {path: '/mailing', components: {default: PageMailing, menu: PartialHeader}, name: 'mailing'},

  {path: '/plans', components: {default: PagePlans, menu: PartialHeader}, name: 'plans'},

  {path: '/finances/dashboard', components: {default: PageFinancesDashboard, menu: PartialHeader}, name: 'finances_dashboard'},
  {path: '/finances/invoices', components: {default: PageFinancesInvoices, menu: PartialHeader}, name: 'finances_invoices'},
  {path: '/finances/accounts', components: {default: PageFinancesAccounts, menu: PartialHeader}, name: 'finances_accounts'},

  {path: '/mktp', components: {default: PageMktp, menu: PartialHeader}, name: 'mktp_home'},

  {path: '/rents/dashboard/:statusId', components: {default: PageRentsDashboard, menu: PartialHeader}, name: 'rents_dashboard'},
  {path: '/rents/list', components: {default: PageRents, menu: PartialHeader}, name: 'rents_list'},
  {path: '/rents/add', components: {default: PageRentsAdd, menu: PartialHeader}, name: 'rents_add'},
  {path: '/rents/details/:rentId', components: {default: PageRentsDetails, menu: PartialHeader}, name: 'rents_details'},

  {path: '/clients/list', components: {default: PageClients, menu: PartialHeader}, name: 'clients_list'},
  {path: '/clients/add/old/:clientId?', components: {default: PageClientsAddOld, menu: PartialHeader}, name: 'clients_add_old'},
  {path: '/clients/add/:clientId?', components: {default: PageClientsAdd, menu: PartialHeader}, name: 'clients_add'},
  {path: '/clients/details/:clientId', components: {default: PageClientsDetails, menu: PartialHeader}, name: 'clients_details'},
  {path: '/clients/resume/:clientId', components: {default: PageClientResume, menu: PartialHeader}, name: 'clients_resume'},

  {path: '/shopping/management', components: {default: PageShoppingManagement, menu: PartialHeader}, name: 'shopping_management'},
  {path: '/shopping/list', components: {default: PageShoppingCatalog, menu: PartialHeader}, name: 'shopping_catalog'},
  {path: '/shopping/list/:id', components: {default: PageShoppingAnnouncement, menu: PartialHeader}, name: 'shopping_announcement'},

  {path: '/products/list', components: {default: PageProducts, menu: PartialHeader}, name: 'products_list'},
  {path: '/products/details/:productId', components: {default: PageProductsDetails, menu: PartialHeader}, name: 'products_details'},
  {path: '/products/details/:productId/sku/:skuId', components: {default: PageProductsSkuDetails, menu: PartialHeader}, name: 'products_sku_details'},

  {path: '/orders/list', components: {default: PageOrders, menu: PartialHeader}, name: 'orders_list'},
  {path: '/orders/details/:orderId', components: {default: PageOrders, menu: PartialHeader}, name: 'order_details'},

  {path: '/image-example', component: PageDatavalidImageExample, name: 'datavalid_example'},

  {path: '*', components: {default: Page404, menu: PartialHeader}, name: 'notfound'}
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  // It was made for manipulate the dropdown menu
  window.$('.dropdown-menu').addClass('force')
  setTimeout(() => {
    window.$('.dropdown-menu').removeClass('force')
  }, 1000)
  // All authenticated routes needs to be putted on this array
  const notAuthenticatedPermitted = ['login', 'password_reset', 'user_registration', 'notfound']
  const user = store.state.user
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title)
  if (nearestWithTitle) window.document.title = nearestWithTitle.meta.title
  if (user && user.company) Vue.$ga.event('navegação - ' + user.company.display_name, to.path)
  // Check if the current route needs auth
  if (!notAuthenticatedPermitted.includes(to.name)) {
    if (user && user.company && user.company.hash && user.access_token) {
      // Condition to redirect companies with expired plan
      if (user.company.status || to.name === 'finances_dashboard') {
        next()
      } else {
        next({name: 'finances_dashboard', query: { buy_credit: 1 }})
      }
    } else {
      next({name: 'login', query: { redirect: to.fullPath }})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js